import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../services/supabase';
import type { Novedad } from '../types';

export function useMisNovedades() {
  return useQuery({
    queryKey: ['mis-novedades'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('vw_mis_novedades')
        .select('*')
        .order('fijada', { ascending: false })
        .order('publicada_at', { ascending: false });
      if (error) throw error;
      return (data ?? []) as Novedad[];
    },
  });
}

export function useMarcarNovedadesLeidas() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (ids: string[]) => {
      const { error } = await supabase.rpc('marcar_novedades_leidas', { p_ids: ids });
      if (error) throw new Error(error.message);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['mis-novedades'] }),
  });
}
